import axios from 'axios';
import { Token } from './token';
import Config from '@/config';

import flags from '@/config/flags.json';

const baseUrl = `${Config.BaseAPI}/v3/concierge`;
const rewardsBaseUrl = `${Config.BaseAPI}/v3/rewards/`;

export default {
  // eslint-disable-next-line max-lines-per-function
  createConcierge: async function(form) {
    const url = `${baseUrl}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    let flag = '';
    if (flags[form.nationality]) {
      flag = flags[form.nationality].split(' ')[1];
    }

    let tempPass = `fast${form.screenName}`.trim().toLowerCase();
    tempPass = tempPass.split(' ').join('');

    let conciergeLevel = 199;

    if (form.isPartnerConcierge) {
      conciergeLevel = 99;
    }

    const body = {
      screenName: form.screenName + flag,
      password: tempPass,
      authMethod: 'email',
      conciergeLevel: conciergeLevel,
      description: Object.assign({}, form.descriptions),
      locations: Object.assign({}, form.location),
      ...form
    };

    const result = await axios.post(url, body, { headers });
    return result;
  },

  getConcierge: async function(conciergeId) {
    const url = `${baseUrl}/${conciergeId}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  },

  listConcierge: async function() {
    const url = `${baseUrl}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  },

  updateConcierge: async function({
    conciergeId,
    langCode = 'en-US',
    ...payload
  }) {
    const url = `${baseUrl}/${conciergeId}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      ['Accept-Language']: langCode,
      'Content-Type': 'application/json'
    };

    const result = await axios.patch(url, payload, { headers });
    return result.data.record;
  },

  updateConciergePayout: async function({ conciergeId, ...payload }) {
    const url = `${baseUrl}/${conciergeId}/payout`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.patch(url, payload, { headers });
    return result.data.record;
  },

  getConciergeRewards: async function(conciergeId) {
    const url = `${rewardsBaseUrl}${conciergeId}/concierge`;
    const token = await Token.getToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  }
};
